import API from '../../path';
import { fetchData } from '@umu/umu-fetch';
import { IStatusResponse } from '@umu/umu-types';

export const finishPk = (id: string): Promise<IStatusResponse> => {
    return fetchData(API.COURSE_PK_FINISH, JSON.stringify({ id }));
};
